import { useEffect } from "react";
import { UNSAFE_useScrollRestoration, useLocation } from "react-router-dom";

const ScrollRestoration = () => {
  UNSAFE_useScrollRestoration();

  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return null;
};

export default ScrollRestoration;
